import { ca } from '@cian/analytics';

export function trackFlatTourBookingButtonClick(id: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'personal_tour_blockJK',
    products: [
      {
        id,
        offerType: 'JK',
      },
    ],
  });
}
